module.exports = __webpack_public_path__ + "static/assets/fb7214f085f0444816f6d8a8b623b89e.svg";